<template>
  <div>
    <ConfigLossToUser 
      :determinatedList="determinatedList"
      :undeterminatedList="undeterminatedList"
    />
    <hr>
    <b-row class="groupBtn">
      <img
        v-if="this.user && this.user.Permissions.editarpap.allowed"
        class="float-right"
        src="@/assets/configuracoes2.png"
        style="margin-left: 8px;"
        :title="$t('configurar-janela')"
        :alt="$t('configurar-janela')"
        @click="showConfig"
      />
      <img
        class="float-right"
        src="@/assets/play.png"
        style="margin-left: 8px;"
        :title="$t('executar-simulacao')"
        :alt="$t('executar-simulacao')"
        @click="executeSimulation"
      />
      <img
        class="float-right"
        src="@/assets/sair.png"
        style="margin-left: 8px; margin-right: 15px;"
        :title="$t('sair')"
        :alt="$t('sair')"
        @click="cancel"
      />
    </b-row>
  </div>
</template>

<script>
import { mapState } from 'vuex';
import { emitEventBuss } from '../../../global';
import ConfigLossToUser from "./template/configLossToUser";

  export default {
    name:"UserConfigInput",
    components: { ConfigLossToUser },
    props: ["determinatedList", "undeterminatedList"],
    computed: mapState(["user"]),

    data() {
      return {
        reloadForm: 0
      }
    },
    methods: {
      cancel(){
        this.$bvModal.hide("ConfigLossAndEfficiencyUser");
      },

      executeSimulation() {
        emitEventBuss("ExecuteSimulation", null)
      },

      showConfig(){
        this.$bvModal.hide("ConfigLossAndEfficiencyUser");
        this.$bvModal.show("ConfigInputToUser");
      },
    },

    mounted() {
      console.log('Iniciando o Reload...');
      this.$emit("reloadForm", this.reloadForm++)
    },
  }
</script>

<style scoped>



</style>